import { useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import { find, pipe, propEq, propOr } from 'ramda';
import { useGeneralRoutes } from '@namespace/cms';
import { MODE } from '../../constants';
import {
  useEventFields,
  useSportsbookStore,
  useTopEventFields,
  useTopPreMatchEventFields
} from '../../store';

type Sport = {
  sportId: number;
  sportSlug: string;
};

type Event = {
  eventId: number;
  inprogress: boolean;
  serviceId: number;
  sportId: number;
};

type UseEventLinkProps = {
  eventId: number;
  isTopEvents: boolean;
  event: Event;
};

export const useEventLink = ({
  eventId,
  isTopEvents,
  event
}: UseEventLinkProps) => {
  const { preMatchEvent, liveEvent } = useGeneralRoutes();
  const eventFields = useEventFields({
    eventId,
    fieldPath: undefined,
    fields: ['inprogress', 'serviceId', 'sportId']
  });

  const topPreMatchEventFields = useTopPreMatchEventFields({
    eventId,
    fields: ['inprogress', 'serviceId', 'sportId']
  });

  const topEventFields = useTopEventFields({
    eventId,
    fields: ['inprogress', 'serviceId', 'sportId']
  });
  // It's need for support old TopEventsMenu
  const actualTopEvents = isEmpty(topPreMatchEventFields)
    ? topEventFields
    : topPreMatchEventFields;

  const { inprogress, serviceId, sportId } =
    event || (isTopEvents ? actualTopEvents : eventFields);

  const sports = useSportsbookStore('sports');

  const sport = useMemo(() => {
    if (sportId == null) {
      return null;
    }

    return pipe(
      propOr([], serviceId.toString()),
      find(propEq(sportId, 'sportId'))
    )(sports) as Sport;
  }, [serviceId, sportId, sports]);

  if (!sportId || !sport) {
    return '';
  }

  const { sportSlug } = sport;
  const serviceLink = serviceId === MODE.IN_PLAY ? liveEvent : preMatchEvent;

  return inprogress
    ? `${liveEvent}/${sportSlug}/${eventId}`
    : `${serviceLink}/${sportSlug}/${eventId}`;
};
